import { FC } from "react";
import { useCreateClass } from "../../../services/class/class.service";
import { useGenericErrorMessage } from "../../../utils/useGenericErrorMessage/useGenericErrorMessage";
import ClassForm from "../ClassForm";
import { CreateClassRequest } from "../../../services/class/class.types";

interface CreateClassFormProps {
  onSuccess: () => void;
}

const CreateClassForm: FC<CreateClassFormProps> = (
    {
      onSuccess
    }
) => {
  const {
    mutate: createClass,
    isLoading: createClassIsLoading,
    isError: createClassIsError,
    error: createClassError
  } = useCreateClass();

  useGenericErrorMessage([
    {
      isError: createClassIsError,
      error: createClassError
    }
  ]);

  const submitForm = (
      requestBody: CreateClassRequest
  ) => {
    createClass(
        requestBody,
        {
          onSuccess: onSuccess
        }
    )
  }

  return (
      <ClassForm
          submitForm={submitForm}
          submitIsLoading={createClassIsLoading}
      />
  )
}

export default CreateClassForm;